import React from "react";
import { convertUTCDateLocal } from "../../../../../utils/convertionFunc";

const VITAL_COLUMN_DETAILS = {
  BP: { label: "Blood Pressure (mmHg)", accessor: "BP" },
  RR: { label: "Respiratory Rate (bpm)", accessor: "RR" },
  TP: { label: "Temperature (°F)", accessor: "TP" },
  HR: { label: "Heart Rate (bpm)", accessor: "HR" },
  SPO2: { label: "SpO2 (%)", accessor: "SPO2" },
  BG: { label: "Blood Glucose", accessor: "BG" },
  WE: { label: "Weight (Kg)", accessor: "WE" },
  HI: { label: "Height (cm)", accessor: "HI" },
  BMI: { label: "BMI (Kg/m²)", accessor: "BMI" },
};

const VITAL_ORDER = ["BP", "HR", "SPO2", "RR", "BMI", "WE", "HI", "TP", "BG"];

function ConfiguredVitalTable({ data, rpmConfigVitalsList, vitalDisplayMap }) {
  let configuredVitalKeys = Object.entries(rpmConfigVitalsList || {})
    .filter(([key, value]) => value === 1 && vitalDisplayMap[key])
    .map(([key]) => vitalDisplayMap[key]);

  const hasBPS = configuredVitalKeys.includes("BPS");
  const hasBPD = configuredVitalKeys.includes("BPD");

  if (hasBPS && hasBPD) {
    configuredVitalKeys = configuredVitalKeys.filter(
      (code) => code !== "BPS" && code !== "BPD",
    );
    configuredVitalKeys.unshift("BP");
  }

  configuredVitalKeys = configuredVitalKeys.filter(
    (code) =>
      code === "BP" ||
      (VITAL_COLUMN_DETAILS[code] && VITAL_COLUMN_DETAILS[code].accessor),
  );

  configuredVitalKeys = [...configuredVitalKeys].sort((a, b) => {
    const ai = VITAL_ORDER.indexOf(a);
    const bi = VITAL_ORDER.indexOf(b);
    const aRank = ai === -1 ? VITAL_ORDER.length : ai;
    const bRank = bi === -1 ? VITAL_ORDER.length : bi;
    return aRank - bRank;
  });

  if (configuredVitalKeys.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center w-full">
        <p className="font-medium text-xl">No configured vitals to display!</p>
      </div>
    );
  }

  const vitalTextColur = (vitalStatus) => {
    if (!vitalStatus) return "#111";
    const status =
      vitalStatus === "NORMAL"
        ? "#111"
        : vitalStatus === "ABNORMAL"
          ? "#FFAA00"
          : vitalStatus === "CRITICAL"
            ? "#FF3411"
            : "#111";
    return status;
  };

  return (
    <div className="w-full overflow-x-auto rounded-lg py-2">
      <table className="w-full min-w-max mx-2 relative">
        <thead className="sticky top-0 bg-white z-10">
          <tr>
            <th>Date & Time</th>
            {configuredVitalKeys.map((vitalCode) => (
              <th key={vitalCode}>{VITAL_COLUMN_DETAILS[vitalCode].label}</th>
            ))}
          </tr>
          <tr className="bg-[#DEF3F2]">
            <td
              className="py-0.5"
              colSpan={configuredVitalKeys.length + 1}
            ></td>
          </tr>
        </thead>
        <tbody className="text-center">
          {data?.map((item, idx) => (
            <React.Fragment key={idx}>
              <tr>
                <td>{convertUTCDateLocal(item.recordedDateTime) || "-"}</td>
                {configuredVitalKeys.map((vitalCode, idx) => {
                  const accessor = VITAL_COLUMN_DETAILS[vitalCode]?.accessor;

                  if (vitalCode === "BP") {
                    return (
                      <td key="BP">
                        <span
                          style={{ color: vitalTextColur(item?.BPS_STATUS) }}
                        >
                          {item?.BPS || "-"}
                        </span>{" "}
                        /{" "}
                        <span
                          style={{ color: vitalTextColur(item?.BPD_STATUS) }}
                        >
                          {item?.BPD || "-"}
                        </span>
                      </td>
                    );
                  }
                  return (
                    <td
                      style={{
                        color: vitalTextColur(item?.[`${vitalCode}_STATUS`]),
                      }}
                    >
                      {item?.[accessor] === 0 ||
                      item?.[accessor] === null ||
                      item?.[accessor] === undefined
                        ? "-"
                        : item?.[accessor]}
                    </td>
                  );
                })}
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ConfiguredVitalTable;
